var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.href)?_c('router-link',{class:[
    ("btn btn-" + _vm.variant),
    { 'btn-w-m': !_vm.size },
    { 'btn-xs': _vm.size === 'xs' },
    { 'btn-sm': _vm.size === 'sm' },
    { 'btn-lg': _vm.size === 'lg' },
    { 'btn-outline': typeof _vm.outline === 'string' },
    { 'btn-rounded': typeof _vm.rounded === 'string' },
    { 'btn-block': typeof _vm.block === 'string' }
  ],attrs:{"to":_vm.href}},[_vm._t("default")],2):_c('button',{ref:"ladda",class:[
    ("btn btn-" + _vm.variant),
    { 'btn-w-m': !_vm.size },
    { 'btn-xs': _vm.size === 'xs' },
    { 'btn-sm': _vm.size === 'sm' },
    { 'btn-lg': _vm.size === 'lg' },
    { 'btn-outline': typeof _vm.outline === 'string' },
    { 'btn-rounded': typeof _vm.rounded === 'string' },
    { 'btn-block': typeof _vm.block === 'string' }
  ],attrs:{"data-style":_vm.efx,"type":_vm.type},on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-273bbb72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/Buttons.vue
// module id = null
// module chunks = 